/* Draft storefront presentation only: leave Moon pricing and variant state intact. */
(() => {
  if (!location.pathname.endsWith('/diffuseur-voiture-parfum-naturel')) return;
  const replacements = new Map([
    ['Diffuseur + Recharge', 'Duo au choix'],
    ['🔥 Jusqu’à 3 remplissages', '2 produits : diffuseurs ou recharges'],
    ['💡 Jusqu’à 6 remplissages', '3 produits : diffuseurs ou recharges'],
    ['Parfum au choix – prêt à l’emploi', 'Choisissez votre produit et votre parfum']
  ]);
  function update() {
    document.querySelectorAll('.moonbundle-option').forEach(option => {
      option.querySelectorAll('span, .moonbundle-option-subtitle').forEach(el => {
        if (el.children.length) return;
        const replacement = replacements.get(el.textContent.trim());
        if (replacement) el.textContent = replacement;
      });
    });
  }
  update();
  const target = document.querySelector('main');
  if (target) new MutationObserver(update).observe(target, {childList:true, subtree:true, characterData:true});
})();
